/* eslint-disable no-undef */
import { otmsHttp, bfsUserWebHttp } from '@/utils/http/index';

// 站点 站点列表
// https://yapi.ops.yunlizhi.cn/project/130/interface/api/13148

export function getSiteList(data) {
  return otmsHttp.post('/base_plus/unify_station/list/v2', data);
}
// 站点 上传站点信息
// https://yapi.ops.yunlizhi.cn/project/130/interface/api/13148
export function upSiteInfo(data) {
  return otmsHttp.post('/base_plus/unify_station/upsert/v2', data);
}

// 站点 站点分页
// https://yapi.ops.yunlizhi.cn/project/130/interface/api/13150

export function getSitePage(data, params) {
  return otmsHttp.post('/base_plus/unify_station/page/v2', data, {
    params,
  });
}

// 站点 站点绑定
// https://yapi.ops.yunlizhi.cn/project/130/interface/api/13152

export function getSiteBind(data) {
  return otmsHttp.post('/base_plus/unify_station/bind', data);
}

// 获取省市区;
export function selectCityAreaTree(data) {
  return otmsHttp.post('/base_plus/city_area/tree', { filterBlackList: true, ...data });
}
//
// 获取Poi;
export function getPoiList(data) {
  return otmsHttp.post('/base_plus/poi/list', data);
}

// 租客模糊搜索
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/6005;
export function gettenantName(data, params) {
  return bfsUserWebHttp.post('/bfs-user/tenant/page', data, { params });
}

// 租客模糊搜索
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/6005;
export function getcustomerName(data, params = { page: 1, size: 10 }) {
  return bfsUserWebHttp.post('/crm_plus/customer/page', data, {
    params,
  });
}
